import * as Yup from "yup";

export const PASSWORD_RULE =
  "Password must be 8-64 chars and include uppercase, lowercase, number, and special character.";

const passwordSchema = Yup.string()
  .required("Password is required")
  .matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,64}$/,
    PASSWORD_RULE
  );

export const loginSchema = Yup.object({
  email: Yup.string().email("Enter a valid email").required("Email is required"),
  password: Yup.string().required("Password is required"),
  remember: Yup.boolean(),
});

export const registerSchema = Yup.object({
  firstName: Yup.string().trim().required("First name is required").max(50, "Max 50 characters"),
  lastName: Yup.string().trim().required("Last name is required").max(50, "Max 50 characters"),
  company: Yup.string().trim().required("Company is required").max(100, "Max 100 characters"),
  email: Yup.string().email("Enter a valid email").required("Email is required"),
  password: passwordSchema,
});

export const forgotPasswordSchema = Yup.object({
  email: Yup.string().email("Enter a valid email").required("Email is required"),
});

export const resetPasswordSchema = Yup.object({
  email: Yup.string().email("Enter a valid email").required("Email is required"),
  password: passwordSchema,
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password")], "Passwords must match"),
});
